var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help"},[_c('Bar',{attrs:{"title":"帮助/反馈"},on:{"goBack":_vm.goBack}}),_c('h4',[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.detail.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }